import { render, staticRenderFns } from "./release_pay.vue?vue&type=template&id=5942908a&scoped=true"
import script from "./release_pay.vue?vue&type=script&lang=js"
export * from "./release_pay.vue?vue&type=script&lang=js"
import style0 from "./release_pay.vue?vue&type=style&index=0&id=5942908a&prod&scoped=true&lang=less"
import style1 from "./release_pay.vue?vue&type=style&index=1&id=5942908a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942908a",
  null
  
)

export default component.exports